import { render, staticRenderFns } from "./weixinData.vue?vue&type=template&id=6f4ebb60&"
import script from "./weixinData.vue?vue&type=script&lang=js&"
export * from "./weixinData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports